import loadable from "@loadable/component";
import { FC, Suspense } from "react";
import { useForm } from "react-hook-form";
import { ICreateCategoryData } from "../../components/Category/CreateCategory";
import Spinner from "../../components/Reusable/Spinner";
import APIS from "../../constant/Endpoint";
import usePostFormData from "../../customHooks/usePostFormData";
import { queryClient } from "../../root.component";
import { ICategorySchema } from "../../utils/validationSchema";

const CreateCategoryComponent = loadable(
  () =>
    import("../../components/Category/CreateCategory") as unknown as Promise<FC>
);

export const CreateCategory = () => {
  const { mutateAsync, isPostLoading } = usePostFormData<ICreateCategoryData>({
    queryKey: ["create-category"],
    navigateURL: "/blog/category",
  });

  const onSubmit = async (data: ICategorySchema, setError: any) => {
    const file = data.preview_image as File;
    delete data.preview_image;
    const url = `${APIS.BLOG_CATEGORY}`;
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      switch (typeof data[key]) {
        case "string":
        case "number":
        case "boolean":
          formData.append(key, data[key]);
          break;
        default:
          formData.append(key, JSON.stringify(data[key]));
      }
    });
    if (file instanceof File) formData.append("preview_image", file);
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res.status === 200) {
        queryClient.refetchQueries();
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Suspense fallback={<Spinner />}>
      <CreateCategoryComponent
        //@ts-ignore
        handleCreate={onSubmit}
        isLoading={isPostLoading}
      />
    </Suspense>
  );
};